import {Dispatch} from 'react'
import {generalOpenModalError, generalOpenModalMessage, generalShowLoader} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import { LIBROS_TYPES } from '../../constants/libros.types'
import { State } from '../../reducers'
import { LibroComprasEditar } from '../../interfaces/libros/compras.interface'

const COMPRAS_FILE = process.env.REACT_APP_COMPRAS_FILE;

export const setFormCompras = (form: any) => ({ type: LIBROS_TYPES.COMPRAS_CHANGE_FORM_CARGA, payload: form })
export const setDataLibrosCompras = (data: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_DATA_LIBROS, payload: data })
export const setLibroActivoCompras = (data: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_LIBRO_ACTIVO, payload: data })
export const setDataFileCompras = (dataFile: any) => ({ type: LIBROS_TYPES.COMPRAS_SET_FILE_DATA_CARGADA, payload: dataFile })
export const setResultJsonHacienda = (jsonResponse: Array<any>) => ({ type: LIBROS_TYPES.JSON_RESPONSE_HACIENDA_DTE, payload: jsonResponse })
export const clearLibroComprasModule = () => ({ type: LIBROS_TYPES.LIBROS_CLEAR_MODULE, payload: {} })

export const getLibrosCompras = () => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  await http
    .post(ENDPOINTS.LIBRO_COMPRAS_GET_GENERADOS, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      const dataLibros = res?.body?.length > 0 ? res.body : [];
      dispatch(setDataLibrosCompras(dataLibros));
    })
    .catch((err) => {
      const messageErr = 'No se logró obtener los datos de los libros';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const postCargarLibrosCompras = (form: any, base64Str: string) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    base64File: base64Str,
    typeFile: form.ext,
    fechaDeclaracion: form.declaracion,
    descripcion: form.descripcion,
    varianteCargaCompras: form.varianteCargaCompras,
    itemsFile: form.datosHacienda ?? [],
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_COMPRAS_CARGAR_NUEVO, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro cargado exitosamente", "Los registros del libro ya fueron ingresados al sistema."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró cargar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const getLibroComprasDetallado = (idLibro: number, exportar:boolean = false, libroActivo: any) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    idLibro,
    exportar,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_COMPRAS_GET_DETALLADO, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(setLibroActivoCompras({libroActivo, detalle: res?.body}));

      if (exportar) {
        const itemExcel = res?.body[0];
        const decodedData = atob(itemExcel?.Excel);
        const byteArray = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; i++) {
          byteArray[i] = decodedData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${COMPRAS_FILE}`;
        // Simular un clic en el enlace de descarga
        document.body.appendChild(a);
        a.click();
        // Limpiar el enlace y el objeto URL
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró exportar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const getJsonDteHacienda = (listadosDte: Array<any>) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formConsulta = {
    listadoBusquedaDte: listadosDte,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_CONSULTA_JSON_DTE, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res.body?.length > 0) {
        dispatch(setResultJsonHacienda(res.body));
      }
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró consultar los documentos con Hacienda, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const deleteLibroCompras = (idlibrocompras: number) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formDelete = {
    idlibrocompras
  }

  return await http
    ._delete(ENDPOINTS.LIBRO_COMPRAS_DELETE, formDelete, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro eliminado", "El libro de compras y sus registros han sido eliminados exitosamente."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró eliminar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

export const deleteLibroComprasDetalle = (detalleLibro: any, libroActivo: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  
  const { detalle } = getState().libros.comprasLibroActivo;
  const formDelete = {
    idlibrocompras: libroActivo?.idlibrocompras,
    numcorrelativo: detalleLibro?.numcorrelativo,
    numcomprobante: detalleLibro?.numcomprobante,
  }

  return await http
    ._delete(ENDPOINTS.LIBRO_COMPRAS_DELETE, formDelete, {}, KEYS.TOKEN)
    .then(async (res: any) => {

      if (detalle?.length > 0) {
        const filterDetalles = detalle?.filter((registro:any) => 
          registro.numcorrelativo !== detalleLibro?.numcorrelativo
        );
        dispatch(setLibroActivoCompras({libroActivo, detalle: filterDetalles}));
        dispatch(generalShowLoader(false));
      } else {
        dispatch(getLibroComprasDetallado(formDelete.idlibrocompras, false, libroActivo));
      }
      
      dispatch(generalOpenModalMessage("Registro eliminado", "El registro del libro de compras ha sido eliminado exitosamente."));
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró eliminar el registro del libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}

export const editLibroCompras = (libroEditado: LibroComprasEditar) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true));

  const formEdit = {
    ...libroEditado,
    descripcion: libroEditado.descripcion.trim(),
  }

  return await http
    .put(ENDPOINTS.LIBRO_COMPRAS_EDIT, formEdit, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Libro editado", "El libro de compras ha sido modificado exitosamente."));
      dispatch(getLibrosCompras());
      return true;
    })
    .catch((err) => {
      const messageErr = 'No se logró editar el libro, intente nuevamente.';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      dispatch(generalShowLoader(false));
      return false;
    });
}